class ContactNotify {
  static getEmailData = (dst, contactInfo) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Nuevo mensaje de contacto de ${contactInfo.name}`;
    const body = templateData(contactInfo);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default ContactNotify;

const templateData = (contactInfo) => {
  return `
      <h2 style="text-align: center;">
        Nuevo mensaje de contacto desde el Portal de Proyectos
      </h2>
      <br />
      <p>Estimado(a) Administrador,</p>
      <br />
      <p>
        Has recibido un nuevo mensaje de contacto desde el Portal de Proyectos. A continuación, se detallan los datos del remitente:
      </p>
      <br />
      <p> 
        <h3>Datos de contacto:</h3>
        <p><strong>Nombre:</strong> ${contactInfo.name}</p>
        <p><strong>Email:</strong> ${contactInfo.email}</p>
        <p><strong>Teléfono:</strong> ${contactInfo.phone}</p>
        <p><strong>Mensaje:</strong> ${contactInfo.message}</p>
      </p>
      <br />
      <p>
        Por favor, responde a este mensaje para atender la solicitud.
      </p>
      <br />
      <br />
      <p>Saludos,</p>
      <br />
      <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
    `;
};
